import { createFileRoute, Outlet } from '@tanstack/react-router';

import logoImage from '@/assets/OKYC logo.webp';

/**
 * Public upload layout - no authentication required.
 * This layout is used for token-based document uploads from clients.
 * Unlike _public routes, it does NOT redirect authenticated users.
 */
export const Route = createFileRoute('/upload')({
  component: UploadLayout,
});

function UploadLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-muted/50">
      {/* Simple header with logo */}
      <header className="border-b bg-background py-4 px-6">
        <img src={logoImage} alt="OKYC" className="h-8" />
      </header>

      {/* Main content */}
      <main className="flex-1 flex justify-center p-4 py-8">
        <div className="w-full max-w-4xl">
          <Outlet />
        </div>
      </main>

      {/* Simple footer */}
      <footer className="border-t bg-background py-4 px-6 text-center text-sm text-muted-foreground">
        Secure document upload powered by OptimalKYC
      </footer>
    </div>
  );
}
